module.exports = __webpack_public_path__ + "img/bg-image-22.1ee90f76.jpg";